/* GWP - Add product to cart without redirection to /cart */
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-gwp-product-form]');

    if (!form) {
      return;
    }

    event.preventDefault();

    const button = form.querySelector('button[type="submit"]');

    if (button && button.disabled) {
      return;
    }

    if (button) {
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
    }

    try {
      const formData = new FormData(form);
      formData.set('quantity', '1');
      formData.set('sections', '{{ section.id }}');
      formData.set('sections_url', window.location.pathname);

      const response = await fetch('{{ routes.cart_add_url }}.js', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });

      if (!response.ok) {
        throw new Error('Erreur lors de l’ajout du cadeau');
      }

      const data = await response.json();

      if (data.sections && data.sections['{{ section.id }}']) {
        const parser = new DOMParser();
        const html = parser.parseFromString(data.sections['{{ section.id }}'], 'text/html');
        const newCartDrawer = html.querySelector('#cart-drawer');
        const currentCartDrawer = document.querySelector('#cart-drawer');

        if (newCartDrawer && currentCartDrawer) {
          currentCartDrawer.innerHTML = newCartDrawer.innerHTML;
          currentCartDrawer.className = newCartDrawer.className;
        }
      }

      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true }));
    } catch (error) {
      console.error(error);

      if (button) {
        button.disabled = false;
      }
    } finally {
      if (button) {
        button.removeAttribute('aria-busy');
      }
    }
  });

  

  /* ==========================================================================
   GWP - Remove gift automatically if cart goes below threshold
   ========================================================================== */

(() => {
  let gwpRemovalInProgress = false;

  const getGwpThreshold = () => {
    const state = document.querySelector('[data-gwp-cart-state]');

    if (!state) {
      return 0;
    }

    return parseInt(state.dataset.gwpThreshold, 10) || 0;
  };

  const isGwpItem = (item) => {
    const value = item?.properties?._gwp;

    return value === true || String(value).toLowerCase() === 'true';
  };

  const getGwpLineItem = (cart) => {
    if (!cart?.items) {
      return null;
    }

    return cart.items.find(isGwpItem) || null;
  };

  const getQualifyingCartTotal = (cart) => {
    if (!cart?.items) {
      return cart?.total_price || 0;
    }

    /*
     * On retire du total du panier la valeur éventuelle du GWP.
     * Ainsi, le cadeau ne peut jamais aider à atteindre son propre palier.
     */
    const gwpTotal = cart.items
      .filter(isGwpItem)
      .reduce((total, item) => {
        return total + (item.final_line_price || 0);
      }, 0);

    return Math.max(
      0,
      (cart.total_price || 0) - gwpTotal
    );
  };

  const removeInvalidGwp = async (cart) => {
    if (gwpRemovalInProgress || !cart) {
      return;
    }

    const threshold = getGwpThreshold();
    const gwpItem = getGwpLineItem(cart);

    /*
     * Pas de palier trouvé ou pas de GWP dans le panier :
     * rien à faire.
     */
    if (!threshold || !gwpItem) {
      return;
    }

    const qualifyingTotal = getQualifyingCartTotal(cart);

    /*
     * Le panier est toujours au-dessus du palier :
     * le client conserve son cadeau.
     */
    if (qualifyingTotal >= threshold) {
      return;
    }

    /*
     * Le panier est passé sous le palier :
     * on supprime automatiquement le GWP.
     */
    gwpRemovalInProgress = true;

    try {
      const sections = [];

      /*
       * On demande à Prestige quelles sections doivent être
       * retournées avec la modification du panier.
       */
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: {
            sections: sections
          }
        })
      );

      const response = await fetch(
        `${Shopify.routes.root}cart/change.js`,
        {
          method: 'POST',

          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },

          body: JSON.stringify({
            id: gwpItem.key,
            quantity: 0,
            sections: sections.join(','),
            sections_url: window.location.pathname
          })
        }
      );

      if (!response.ok) {
        throw new Error(
          'Impossible de supprimer automatiquement le GWP.'
        );
      }

      const updatedCart = await response.json();

      /*
       * PAGE PANIER
       *
       * On recharge la page après suppression du GWP.
       * Le Liquid recalculera alors :
       *
       * gwp_product_in_cart = false
       *
       * et la section de sélection du GWP réapparaîtra.
       */
      if (
        window.themeVariables?.settings?.pageType === 'cart'
      ) {
        window.location.reload();
        return;
      }

      /*
       * CART DRAWER
       *
       * On déclenche l'événement natif Prestige.
       * Le drawer récupère les sections retournées par
       * cart/change.js et se met à jour sans redirection.
       */
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:change', {
          bubbles: true,

          detail: {
            baseEvent: 'gwp:auto-remove',
            cart: updatedCart
          }
        })
      );

    } catch (error) {

      console.error('[GWP]', error);

    } finally {

      gwpRemovalInProgress = false;

    }
  };

  /*
   * CART DRAWER
   *
   * À chaque modification du panier :
   * quantité + / -
   * suppression d'un produit
   * ajout d'un produit
   *
   * on vérifie si le GWP est encore légitime.
   */
  document.addEventListener(
    'cart:change',
    (event) => {

      if (!event.detail?.cart) {
        return;
      }

      removeInvalidGwp(event.detail.cart);

    }
  );

  /*
   * PAGE PANIER + SÉCURITÉ AU CHARGEMENT
   *
   * Si quelqu'un arrive directement sur /cart avec
   * un GWP devenu invalide, on vérifie également
   * l'état réel du panier Shopify.
   */
  const checkCurrentCart = async () => {

    if (
      !document.querySelector('[data-gwp-cart-state]')
    ) {
      return;
    }

    try {

      const response = await fetch(
        `${Shopify.routes.root}cart.js`,
        {
          headers: {
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        }
      );

      if (!response.ok) {
        return;
      }

      const cart = await response.json();

      removeInvalidGwp(cart);

    } catch (error) {

      console.error('[GWP]', error);

    }
  };

  /*
   * Fonctionne que custom.js soit chargé avant
   * ou après DOMContentLoaded.
   */
  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      checkCurrentCart,
      {
        once: true
      }
    );

  } else {

    checkCurrentCart();

  }

})();